import React, { useEffect, useState, useRef, useContext } from 'react'
import { useLocation } from "react-router-dom";
// * Helpers
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
// import { useTranslation } from 'react-i18next';
// Import axios
import { AMS, PUBLIC } from "../../services/api";
// Context
import AuthContext from '../../context/Auth/AuthContext';
// Spinner
import { Loader } from "@progress/kendo-react-indicators";
// graphSelector component instance
import GraphSelectors from './graphSelectors';

const GraphView = (props) => {
    // const { t } = useTranslation('common');
    //* To can acess the parameters sent via history.push
    const location = useLocation();
    // if we need change the dimension of rows or columns of the spread, we need no show the spread, so that it reload
    const [showGraph, setShowGraph] = useState(true);

    const [graphMetadata, setGraphMetadata] = useState(null);

    // Session context to get the current institution data
    const { user } = useContext(AuthContext);

    // this useEffect is executed each time the selectedNodeData variable is updated in the graphControl component
    useEffect(() => {
        //When tree change this useeffect update the graph
        if (props.selectedNodeData) {
            setShowGraph(false)
            getGraphMeta(props.selectedNodeData.code)
            getGraph(props.selectedNodeData.code, props.selectedNodeData.initialSelectors);
        }
    }, [props.selectedNodeData]);// eslint-disable-line react-hooks/exhaustive-deps

    // Gets the metadata of the selected graph
    const getGraphMeta = async (graphCode) => {
        try {
            const res = await AMS.get(`/dashboardmetadata/SCENARIO/${location.state.detail.scenarioId}/${graphCode}`, {
                params: {
                    usr: user.email
                }
            });
            // If the request fails
            if (res.data.result === -1) {
                Notifications.notify(res.data.message, ERROR_NOTIFICATION);
                props.setBlockTree(false);
                return;
            }
            setGraphMetadata(res.data)
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
            props.setBlockTree(false);
        }
    }

    const getGraph = async (graphCode, selectors) => {
        // http://127.0.0.1:5000/matrix/dashboard/SCENARIO/6/dashboard1/sboth=0?usr=aaraya@grupoasesor.net
        try {
            const res = await AMS.get(`/dashboard/SCENARIO/${location.state.detail.scenarioId}/${graphCode}/${selectors}`, {
                params: {
                    usr: user.email
                }
            });

            if (res.data.result === -1) {
                Notifications.notify(res.data.message, ERROR_NOTIFICATION);
                props.setBlockTree(false);
                return;
            }
            
            // Show the graph using the bokeh dependecy
            setTimeout(() => {
                setShowGraph(false);
                window.Bokeh.embed.embed_item(JSON.parse(res.data.data), 'myplot');
                setShowGraph(true);
            }, 2000);
            
            props.setBlockTree(false);

        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error);
            props.setBlockTree(false);
        }
    }

    return (
        <>
            <div className="row matrix_title_row">
                <GraphSelectors
                    graphMetadata={graphMetadata}
                    selectedNodeData={props.selectedNodeData}
                    getGraph={getGraph}
                    showGraph={showGraph}
                    setShowGraph={setShowGraph}
                    key={props.selectedNodeData.id}
                />
            </div>
            <div className="row  row_attrs graph-view">
                <div className="col-md-12" >
                    {showGraph ? (
                        <div id='myplot' className="bk-root graph-view-bokeh"></div>
                    ) : <Loader size="large" type="converging-spinner" />}
                </div>
            </div>
        </>

    );
}

export default GraphView